import {
  ControlWithDescription,
  InlineWithDescription,
} from 'components/form-layouts';

import { RffInput } from '@cast/shared-rff-ui';

export const CRISocketPathSection = () => (
  <InlineWithDescription
    description={
      <ControlWithDescription label="CRI socket path">
        Path to the Container Runtime Interface socket on the node.
      </ControlWithDescription>
    }
    controls={
      <RffInput
        name="criSocketPath"
        label="CRI socket path"
        inputProps={{
          placeholder: 'e.g. /run/containerd/containerd.sock',
        }}
        testId="cri-socket-path-input"
      />
    }
  />
);
